var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Module, ModuleAvatar, ModuleContent, ModuleHeader, ModuleBody, ModuleFooter, NavAction, ButtongroupInline, ButtonSecondary, FieldText } from '../';

import InboxMessageHeaders from "./InboxMessageHeaders";

var InboxMessageReply = (_temp2 = _class = function (_Component) {
    _inherits(InboxMessageReply, _Component);

    function InboxMessageReply() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxMessageReply);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChangeMessage = function (message) {
            var formData = _this.props.formData;


            if (_this.props.onChange) {
                _this.props.onChange(_extends({}, formData, { message: message }));
            }
        }, _this.onSave = function (status) {
            if (_this.props.onSave) {
                _this.props.onSave(status);
            }
        }, _this.onDiscard = function () {
            if (_this.props.onDiscard) {
                _this.props.onDiscard();
            }
        }, _this.renderFooter = function () {

            var saveButton = {
                title: "Send",
                onClick: function onClick() {
                    return _this.onSave();
                },
                children: [{
                    title: "Save as draft",
                    onClick: function onClick() {
                        return _this.onSave('draft');
                    }
                }, {
                    title: "Save and publish",
                    onClick: function onClick() {
                        return _this.onSave('publish');
                    }
                }]
            };

            var discardButton = {
                title: "Discard",
                onClick: _this.onDiscard
            };

            return React.createElement(
                ModuleFooter,
                null,
                React.createElement(
                    ButtongroupInline,
                    null,
                    React.createElement(NavAction, { button: saveButton, align: 'left', buttonType: 'secondary' }),
                    React.createElement(ButtonSecondary, discardButton)
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxMessageReply.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            expanded = _props.expanded,
            formData = _props.formData;
        var date = formData.date,
            author = formData.author,
            status = formData.status,
            to = formData.to,
            message = formData.message;


        return React.createElement(
            'article',
            { className: className },
            React.createElement(InboxMessageHeaders, { author: author, replyTo: to }),
            React.createElement(
                ModuleBody,
                null,
                React.createElement(FieldText, { rows: '3', value: message, onChange: this.onChangeMessage })
            ),
            this.renderFooter()
        );
    };

    return InboxMessageReply;
}(Component), _class.defaultProps = {
    className: "admin-inbox-message__reply"
}, _temp2);


export default InboxMessageReply;